import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=1f828a4a&scoped=true"
import script from "./IconDelete.vue?vue&type=script&lang=js"
export * from "./IconDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f828a4a",
  null
  
)

export default component.exports